// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gvASuZ[data-testid] {
  z-index: 1300;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorRechargeReportToast/EmissorRechargeReportToast.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".aboveDrawer[data-testid] {\n  z-index: 1300;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboveDrawer": `gvASuZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
